import React from 'react';
import Logo from './assets/logo-bolao-top-cropped.png';

const PrivacyPolicy = ({ onBack }) => {
    return (
        <div className="flex flex-col min-h-screen text-slate-200 font-sans bg-slate-900">
            {/* Navigation */}
            <nav className="sticky top-0 z-50 w-full border-b border-slate-700 shadow-lg" style={{ background: 'rgba(30, 41, 59, 0.7)', backdropFilter: 'blur(10px)', paddingTop: 'env(safe-area-inset-top)' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-20">
                        <div className="flex-shrink-0 flex items-center cursor-pointer hover:opacity-80 transition-opacity" onClick={onBack}>
                            <img src={Logo} alt="Bolões Top" className="h-16 w-auto" />
                        </div>
                        <div>
                            <button
                                onClick={onBack}
                                className="text-slate-300 hover:text-white font-bold py-2 px-4 transition-colors"
                            >
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-slate-800 rounded-2xl p-8 md:p-12 shadow-xl border border-slate-700">
                    <h1 className="text-3xl md:text-4xl font-bold text-white mb-8 border-b border-slate-700 pb-4">Política de Privacidade</h1>

                    <div className="space-y-6 text-slate-300 leading-relaxed">
                        <p>
                            A sua privacidade é importante para nós. Esta Política de Privacidade descreve como o Bolões TOP coleta, usa e protege as informações dos usuários ao utilizar nosso aplicativo e site.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">1. Informações que coletamos</h2>
                        <p>Coletamos as seguintes informações ao utilizar nosso serviço:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Nome ou apelido</li>
                            <li>Endereço de e-mail</li>
                            <li>Dados de autenticação (como senha, armazenada de forma segura)</li>
                        </ul>
                        <p>
                            Também oferecemos a opção de login por meio de contas de terceiros, como o Google. Nesse caso, podemos receber informações básicas do perfil, como nome e e-mail.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">2. Uso das informações</h2>
                        <p>As informações coletadas são utilizadas para:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Criar e gerenciar a conta do usuário</li>
                            <li>Permitir a participação em bolões</li>
                            <li>Melhorar a experiência do usuário</li>
                            <li>Garantir a segurança da plataforma</li>
                        </ul>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">3. Compartilhamento de dados</h2>
                        <p>Não compartilhamos suas informações pessoais com terceiros, exceto:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Quando exigido por lei</li>
                            <li>Quando necessário para funcionamento do serviço (ex: autenticação via Google)</li>
                        </ul>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">4. Armazenamento e segurança</h2>
                        <p>
                            Os dados são armazenados de forma segura e protegidos contra acesso não autorizado. Utilizamos criptografia em trânsito (HTTPS) para proteger as informações.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">5. Retenção de dados</h2>
                        <p>
                            Mantemos os dados apenas pelo tempo necessário para fornecer nossos serviços ou conforme exigido por lei.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">6. Direitos do usuário</h2>
                        <p>
                            O usuário pode solicitar a exclusão de sua conta e dados a qualquer momento entrando em contato conosco.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">7. Links externos</h2>
                        <p>
                            Nosso aplicativo pode conter links para sites externos. Não nos responsabilizamos pelas políticas de privacidade desses sites.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">8. Alterações nesta política</h2>
                        <p>
                            Podemos atualizar esta Política de Privacidade periodicamente. Recomendamos que o usuário revise esta página regularmente.
                        </p>

                        <h2 className="text-xl font-bold text-white mt-8 mb-4">9. Contato</h2>
                        <p>
                            Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco pelo e-mail: <a href="mailto:contato@boloestop.com.br" className="text-blue-400 hover:underline">contato@boloestop.com.br</a>
                        </p>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <footer className="bg-slate-950 border-t border-slate-800 pt-12 pb-8 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-600">
                        <p>&copy; 2026 Bolões Top. Todos os direitos reservados.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;
